module.exports = __webpack_public_path__ + "img/text-and-image-row-right.edbb068b.svg";